export const defaultLargeButtonMinWidth = 40;
